import { memo } from "react"

import { Href } from "~/shared/ui"

import cssModule from "./index.module.scss"
import { cx } from "classix"
import { isMobileOrStandalone } from "~/shared/ui/constants"

export type HeaderProps = {
	org?: string
	orgUrl?: string
	title?: string
	titleUrl?: string
	subtitle?: string
}

export const Header = memo(function Header({ org, orgUrl = "", title, titleUrl = "", subtitle }: HeaderProps) {
	return (
		<header className={cx(cssModule.header)}>
			<div>
				{!isMobileOrStandalone && <Href className={cssModule.orgName} href={orgUrl}>
					<div>{org}</div>
				</Href>}
				{!isMobileOrStandalone && <h2 className={cssModule.title}>
					<Href href={titleUrl}>{title}</Href>
				</h2>}
				{!isMobileOrStandalone && subtitle && <h3 className={cssModule.subtitle}>{subtitle}</h3>}
			</div>
		</header>
	)
})
